import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { enqueueSnackbar } from 'notistack';
import { dispatch, store } from 'store';
import UserConfigModel from 'types/userConfig/userConfig';
import { fetcher } from 'utils/axios';
import { updateSingleApplicationUser } from './applicationUsers';

const initialState: UserConfigModel = {
  isDisplayName: false,
  isAvatarActive: false,
  isDateTime: true,
  showDate: false,
  fontSize: '14',
  isMssgRTL: 'true',
  submitType: {
    ctrlEnter: [
      {
        //TODO text: currentLocale.settingsPopup.userConfig.tabs.chats.leftColumn
        //   .submitTypes.ctrlEnter.breakLine,
        text: 'Break line',
        checked: true,
      },
      {
        //TODO text: currentLocale.settingsPopup.userConfig.tabs.chats.leftColumn
        //   .submitTypes.ctrlEnter.sendMessage,
        text: 'Send message',
        checked: false,
      },
    ],
    shiftEnter: [
      {
        //TODO text: currentLocale.settingsPopup.userConfig.tabs.chats.leftColumn
        //   .submitTypes.shiftEnter.breakLine,
        text: 'Break line',
        checked: true,
      },
      {
        //TODO text: currentLocale.settingsPopup.userConfig.tabs.chats.leftColumn
        //   .submitTypes.shiftEnter.sendMessage,
        text: 'Send message',
        checked: false,
      },
    ],
    enter: [
      {
        //TODO text: currentLocale.settingsPopup.userConfig.tabs.chats.leftColumn
        //   .submitTypes.enter.breakLine,
        text: 'Break line',
        checked: false,
      },
      {
        //TODO text: currentLocale.settingsPopup.userConfig.tabs.chats.leftColumn
        //   .submitTypes.enter.sendMessage,
        text: 'Send message',
        checked: true,
      },
    ],
  },
  isNotifOn: true,
  enableCustomTime: true,
  notifHintTimeout: 5,
  displayInfoBots: true,
  displayInfoAssignee: true,
  audioNotifVol: 0.5,
  openChatAuthControl: true,
  predefinedAIPrompts: [],
  aiConnections: [],
  //* Filters
  unreadFilter: false,
  openCloseFilter: 'all',
  chatUsersTable: {
    columnsVisibility: {},
    columnsSizes: {},
  },
  //* Priority
  priorityContactsPagination: true,
  //* Views
  useViews: false,
  customViews: [],
  showUnreadPreviewOnHover: true,
};

const userConfigSlice = createSlice({
  name: 'userConfig',
  initialState,
  reducers: {
    updateUserConfig(state, action: PayloadAction<Partial<UserConfigModel>>) {
      Object.assign(state, action.payload);
    },
    resetUserConfig() {
      return initialState;
    },
  },
});

export default userConfigSlice.reducer;
export const { updateUserConfig, resetUserConfig } = userConfigSlice.actions;

export async function getUserConfig() {
  try {
    const userData = store.getState().user;
    const userConfigData = await fetcher(
      'post',
      ['/api/services/GetUserConfig', { data: { userId: userData?.Udid } }],
      'history',
    );
    if (userConfigData.result) {
      const parsedUserConfig: Partial<UserConfigModel> = JSON.parse(userConfigData.profileConfig);
      dispatch(updateUserConfig(parsedUserConfig));
    }
  } catch (error) {
    console.warn('getUserConfig error: ', error);
  }
}
export async function fetchUpdateUserConfig(
  params: Partial<UserConfigModel>,
  sendNotification: boolean = true,
  userId?: string,
) {
  try {
    const currentUserConfig = store.getState().userConfig;
    const userData = store.getState().user;
    if (!currentUserConfig) {
      console.warn('fetchUpdateUserConfig: No user config yet');
      return;
    }

    const updatedUserConfigData = { ...currentUserConfig, ...params };
    const fetchParams = {
      userId: userId ? userId : userData?.Udid || '',
      optionsList: JSON.stringify(updatedUserConfigData),
    };

    const data = await fetcher('post', ['/api/services/UpdateUserConfig', { data: fetchParams }], 'history');
    if (data.result && (!userId || userId === userData?.Udid)) {
      dispatch(updateUserConfig(params));
    }
    dispatch(
      updateSingleApplicationUser({
        userId: userId ? userId : userData?.Udid || '',
        params: { ProfileConfig: JSON.stringify(updatedUserConfigData) },
      }),
    );
    if (sendNotification) {
      // בדיקה אם זה עדכון של תצוגות מותאמות אישית
      if (params.customViews) {
        const currentViews = currentUserConfig.customViews || [];
        const newViews = params.customViews || [];
        
        if (newViews.length > currentViews.length) {
          // נוספה תצוגה חדשה
          const newView = newViews.find(view => !currentViews.some(existingView => existingView.id === view.id));
          enqueueSnackbar(data.result ? `התצוגה "${newView?.name}" נוצרה בהצלחה` : 'שגיאה ביצירת התצוגה', {
            variant: data.result ? 'success' : 'error',
          });
        } else if (newViews.length < currentViews.length) {
          // נמחקה תצוגה
          const deletedView = currentViews.find(view => !newViews.some(newView => newView.id === view.id));
          enqueueSnackbar(data.result ? `התצוגה "${deletedView?.name}" נמחקה בהצלחה` : 'שגיאה במחיקת התצוגה', {
            variant: data.result ? 'success' : 'error',
          });
        } else {
          // עודכנה תצוגה קיימת
          enqueueSnackbar(data.result ? 'התצוגה עודכנה בהצלחה' : 'שגיאה בעדכון התצוגה', {
            variant: data.result ? 'success' : 'error',
          });
        }
      } else {
        // עדכון רגיל של הגדרות משתמש
        enqueueSnackbar(data.result ? 'ההגדרות נשמרו בהצלחה' : 'שגיאה בשמירת ההגדרות', {
          variant: data.result ? 'success' : 'error',
        });
      }
    }
  } catch (error) {
    console.warn('fetchUpdateUserConfig err: ', error);
    if (sendNotification)
      enqueueSnackbar('שגיאה בעדכון ההגדרות', {
        variant: 'error',
      });
  }
}
